import React from "react";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import classNames from "classnames/bind";

// components
import { Rating } from "../components";

//  utils
import { convertToSlug } from "src/utils/helpers";

// assets
import { LocationIcon, Calender } from "src/assets/icons";

import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const Item = ({ data }) => {
  const history = useHistory();

  const trimTitle = (_title) => {
    _title = _title.trim();

    if (_title.length > 50) {
      _title = _title.substring(0, 50);
      _title += "...";
    }

    return _title;
  };

  const trimLocation = (_location) => {
    _location = _location.trim();

    if (_location.length > 27) {
      _location = _location.substring(0, 27);
      _location += "...";
    }

    return _location;
  };

  return (
    <div
      className={styles.item}
      onClick={() => {
        if (Object.entries(data).length > 0) {
          let slug = convertToSlug(data?.EventName);
          history.push(`/${slug}/${data?.EventId}/${data?.TimeId}`);
        }
      }}
    >
      <div className={styles.img_wrap}>
        {data?.Image ? (
          <img
            src={data?.Image}
            alt={data?.EventName}
            className={styles.main_image}
          />
        ) : (
          <Skeleton className={styles.main_image} />
        )}
        <div className={styles.category}>{data?.CategoryName}</div>
      </div>
      <div className={styles.wrap}>
        <h4 className={styles.title}>
          {/* {trimTitle(data?.eventName || "") || <Skeleton />} */}
          {data?.EventName || <Skeleton />}
        </h4>
        <Rating size="xs" rate={0} />
        <p className={cx("location")}>
          <LocationIcon />
          {/* <span>{trimLocation(data?.location || "")}</span> */}
          <span>{data?.Location}</span>
        </p>
        <p className={cx("start-time")}>
          <Calender />
          <span>{data?.StartTime}</span>
        </p>
      </div>
    </div>
  );
};

export default Item;
